import React from 'react';
import { Paper } from '@material-ui/core';
import { useLocation } from 'react-router-dom';
import { Program } from 'models';
import withBreadcrumbs from 'hocs/withBreadcrumbs';
import AddNewMessageForm from '../form';
import useStyles from './style';

interface StateProps {
  program?: Program;
}

const AddNewProgram: React.FC<{}> = () => {
  const classes = useStyles();
  const location = useLocation();
  const state = location.state as StateProps;
  const program = state ? state.program : undefined;

  return (
    <Paper className={classes.container}>
      <AddNewMessageForm program={program} />
    </Paper>
  );
};

export default withBreadcrumbs(AddNewProgram);
